module.exports = __webpack_public_path__ + "zilla-slab-latin-400italic.956354a01f3b7a9632757a7d7efbd4f0.woff";